import { Navigate, Outlet } from "react-router-dom";
import SideBar from "../components/side-bar/side-bar";
import NavBar from "../components/nav-bar/nav-bar";
import { useSelector, useDispatch } from 'react-redux';
import { useEffect, useRef } from 'react';
import { fetchAdminDetails } from '../store/slices/authSlice';

const PrivateRoute = () => {
    const dispatch = useDispatch();
    const { isLoggedIn, user } = useSelector((state) => state.auth);

    useEffect(() => {
        // Fetch admin details on initial mount (browser refresh) to refresh permissions
        // Handle both cases: user object with nested admin or plain user object
        const getUserFromStorage = () => {
            try {
                const storedUser = localStorage.getItem("user");
                if (!storedUser) return null;
                
                const parsed = JSON.parse(storedUser);
                // Check if it's nested { admin: {...} } or plain object
                return parsed?.admin?._id ? parsed.admin : (parsed?._id ? parsed : null);
            } catch (error) {
                console.error("Error parsing user from localStorage:", error);
                return null;
            }
        };

        const storedUser = getUserFromStorage();
        const token = localStorage.getItem("token");
        
        if (token && storedUser && storedUser._id) {
            console.log("Browser refresh detected - Fetching admin details for user:", storedUser._id);
            dispatch(fetchAdminDetails(storedUser._id));
        }
    }, [dispatch]);

    return (
        <div className="flex h-screen w-full overflow-hidden">
            <SideBar />
            <div className="flex-1 flex flex-col">
                <NavBar />

                <div className="flex-grow p-6 bg-gray-100 overflow-y-auto">
                    <div className="container mx-auto w-full overflow-hidden" style={{ zIndex: "1" }}>
                        {isLoggedIn ? <Outlet /> : <Navigate to="/login" />}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default PrivateRoute;
